var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 6.58333V9.91667M14.0833 4.91667V8.25M13.25 0.75C15.2906 0.75 16.3943 1.0623 16.9434 1.30454C17.0166 1.33679 17.0531 1.35292 17.1587 1.45364C17.2219 1.51402 17.3374 1.69116 17.3671 1.77341C17.4167 1.91062 17.4167 1.98562 17.4167 2.13562V11.0926C17.4167 11.8499 17.4167 12.2286 17.3031 12.4232C17.1876 12.6212 17.0762 12.7132 16.86 12.7893C16.6474 12.8641 16.2183 12.7817 15.3601 12.6168C14.7595 12.5014 14.0471 12.4167 13.25 12.4167C10.75 12.4167 8.25 14.0833 4.91667 14.0833C2.87608 14.0833 1.77239 13.771 1.22324 13.5288C1.1501 13.4965 1.11354 13.4804 1.008 13.3797C0.944739 13.3193 0.829265 13.1422 0.799558 13.0599C0.75 12.9227 0.75 12.8477 0.75 12.6977L0.75 3.74071C0.75 2.9834 0.75 2.60475 0.863565 2.41012C0.979085 2.21214 1.09049 2.1201 1.30672 2.04401C1.51928 1.96921 1.94836 2.05165 2.80652 2.21654C3.40718 2.33195 4.11957 2.41667 4.91667 2.41667C7.41667 2.41667 9.91667 0.75 13.25 0.75ZM11.1667 7.41667C11.1667 8.56726 10.2339 9.5 9.08333 9.5C7.93274 9.5 7 8.56726 7 7.41667C7 6.26607 7.93274 5.33333 9.08333 5.33333C10.2339 5.33333 11.1667 6.26607 11.1667 7.41667Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/currency-icon.da1b97a5be112f74a1d972df4d912138.svg";
export { ForwardRef as ReactComponent };